export default {"src":"/_next/static/media/gift_box_open.55aeab0a.svg","height":118,"width":104};